import { defineComponent, h } from 'vue';

export const Hooper = defineComponent({
  name: 'Hooper',
  props: {
    settings: Object
  },
  setup(props, { slots }) {
    return () => h('div', { class: 'hooper-mock' }, slots.default ? slots.default() : []);
  }
});

export const Slide = defineComponent({
  name: 'Slide',
  setup(props, { slots }) {
    return () => h('div', { class: 'hooper-slide-mock' }, slots.default ? slots.default() : []);
  }
});

export const Navigation = defineComponent({
  name: 'HooperNavigation',
  setup() {
    return () => h('div', { class: 'hooper-navigation-mock' });
  }
});

export default Hooper;
